import { useContext, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { SidebarContext } from "context/SidebarContext";
import PurchasebillServices from "services/PurchasebillServices";
import { notifyError, notifySuccess } from "utils/toast";
const adminInfo = localStorage.getItem("adminInfo")
  ? JSON.parse(localStorage.getItem("adminInfo"))
  : null;
const id_employee = adminInfo?.id ? adminInfo.id : 0;
const useBillSubmit = (data,  va_id, bill_amount, bill_images) => {
  const { isDrawerOpen, closeDrawer, setIsUpdate } = useContext(SidebarContext);
  const [billImagesUrl1, setBillImagesUrl1] = useState([]);
  const [billImagesUrl2, setBillImagesUrl2] = useState([]);
  const [loading, setLoading] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const {
    register,
    handleSubmit,
    setValue,
    trigger,
    formState: { errors },
  } = useForm();

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      setIsSubmitting(true);

      const payload = {
        bill_amount: data.bill_amount,
        // total_km: data.total_km,
        // calculation: data.calculation,
        remarks:data.remark || "",
        bill_images: data.bill_images || [],
        // is_vendor: false,
        // id: id_employee,
      };

      const res =
        bill_amount > 0
          ? await PurchasebillServices.updateBill(va_id, payload)
          : await PurchasebillServices.addBill(va_id, payload);

      notifySuccess(res.message);
      setIsUpdate(true);
      closeDrawer();
    } catch (err) {
      notifyError(err?.response?.data?.message || err.message);
    } finally {
      setIsSubmitting(false);
      setLoading(false);
    }
  };

  useEffect(() => {
    if (va_id) {
      (async () => {
        try {
          if (bill_amount > 0) {
            setValue("bill_amount", bill_amount);
          }
          // if (data.total_km > 0) {
          //   setValue("total_km", data.total_km);
          // }
          // setValue("calculation", data.calculation);

          if (bill_images && bill_images.length > 0) {
            // Separate the two images
            const [image1, image2] = bill_images;

            setBillImagesUrl1(image1 || "");
            setBillImagesUrl2(image2 || "");
          }
        } catch (err) {
          notifyError(err?.response?.data?.message || err.message);
        }
      })();
    }

    if (!isDrawerOpen) {
      setBillImagesUrl1("");
      setBillImagesUrl2("");
    }

    // eslint-disable-next-line
  }, [va_id, isDrawerOpen]);
        
  return {
    trigger,
    register,
    handleSubmit,
    onSubmit,
    errors,
    billImagesUrl1,
    setBillImagesUrl2,
    billImagesUrl2,
    loading,
    setLoading,
    setBillImagesUrl1,
    isSubmitting,
  };  
};

export default useBillSubmit;
